/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LastOpenedClientResponse
 */
export interface LastOpenedClientResponse {
    /**
     * 
     * @type {string}
     * @memberof LastOpenedClientResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LastOpenedClientResponse
     */
    salutation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LastOpenedClientResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof LastOpenedClientResponse
     */
    lastName: string;
    /**
     * 
     * @type {Date}
     * @memberof LastOpenedClientResponse
     */
    openedAt: Date;
}

/**
 * Check if a given object implements the LastOpenedClientResponse interface.
 */
export function instanceOfLastOpenedClientResponse(value: object): value is LastOpenedClientResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('openedAt' in value) || value['openedAt'] === undefined) return false;
    return true;
}

export function LastOpenedClientResponseFromJSON(json: any): LastOpenedClientResponse {
    return LastOpenedClientResponseFromJSONTyped(json, false);
}

export function LastOpenedClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastOpenedClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'salutation': json['salutation'] == null ? undefined : json['salutation'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'openedAt': (new Date(json['openedAt'])),
    };
}

export function LastOpenedClientResponseToJSON(json: any): LastOpenedClientResponse {
    return LastOpenedClientResponseToJSONTyped(json, false);
}

export function LastOpenedClientResponseToJSONTyped(value?: LastOpenedClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'salutation': value['salutation'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'openedAt': value['openedAt'].toISOString(),
    };
}

